import { render, staticRenderFns } from "./UserLocationSection.vue?vue&type=template&id=7bea1908&scoped=true&"
import script from "./UserLocationSection.vue?vue&type=script&lang=js&"
export * from "./UserLocationSection.vue?vue&type=script&lang=js&"
import style0 from "./UserLocationSection.vue?vue&type=style&index=0&id=7bea1908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bea1908",
  null
  
)

export default component.exports